import apiEndpoints from "../config/apiEndpoints";
import axiosInstance from "../api/axiosInstance";
import { vereist, spoor } from './verzoek';
import { bewerkKoppen } from '../lib/bewerkmodus';

// Elke dienst hieronder zegt wat hij nodig heeft, zegt wat hij ophaalt, en doet dat. Gaat er
// iets mis, dan gooit hij: de aanroeper weet als enige wat de gast op dat moment hoort te zien.
// Het naar Sentry sturen gebeurt in de onderschepper van axios, op een plek. (WI5)

const FetchWebshopSettings = async (key) => {
    vereist('FetchWebshopSettings', { key });

    spoor("Fetching webshop settings", { key });

    return axiosInstance.get(apiEndpoints?.GET_WEBSHOP_WIDGET_SETTINGS(key));
};

const fetchExternalDeviceConfig = async (key, UID) => {
    vereist('fetchExternalDeviceConfig', { key, UID });

    spoor("Fetching external device configuration", { key, UID });

    return axiosInstance.get(apiEndpoints?.GET_EXTERANAL_DEVICE_CONFIG(key, UID));
};

// soort (bezorgplanning, 13-10-2026): "delivery", "pickup" of "DineIn"; bij bezorgen alleen tijden binnen de bezorguren van vandaag.
const FetchDeliverySlots = async (key, soort) => {
    vereist('FetchDeliverySlots', { key });

    spoor("Fetching delivery slots", { key, soort });

    return axiosInstance.get(apiEndpoints?.GET_DELIVERY_SLOTS(key, soort));
};

// Bezorgplanning (13-10-2026): de bezorgdagen en tijdsloten bij een postcode. planning: false = zoals altijd.
export const FetchBezorgmomenten = async (key, postcode) => {
    vereist('FetchBezorgmomenten', { key });

    spoor("Fetching bezorgmomenten", { key });

    return axiosInstance.get(apiEndpoints?.GET_BEZORGMOMENTEN(key, postcode));
};

const FetchWebShopCategories = async (key, lang, id) => {
    vereist('FetchWebShopCategories', { key, lang });

    spoor("Fetching webshop categories", { key, lang, id });

    return axiosInstance.get(apiEndpoints?.GET_WEBSHOP_CATEGORIES(key, lang, id));
};

const FetchWebShopProductList = async (key, lang, categoryId) => {
    vereist('FetchWebShopProductList', { key, lang });

    spoor("Fetching webshop product list", { key, lang, categoryId });

    return axiosInstance.get(
        apiEndpoints?.GET_WEBSHOP_PRODUCTSLIST(key, lang, categoryId)
    );
};

const FetchWebshopProductsInfo = async (key, lang, productId) => {
    vereist('FetchWebshopProductsInfo', { key, lang, productId });

    spoor("Fetching webshop product info", { key, lang, productId });

    return axiosInstance.get(
        apiEndpoints?.GET_WEBSHOP_PRODUCT_DETAILS(key, lang, productId)
    );
};

const CreateWebShopOrder = async (data) => {
    vereist('CreateWebShopOrder', { data });

    spoor("Creating webshop order", {});

    return axiosInstance.post(apiEndpoints?.CREATE_WEBSHOP_ORDER, data);
};

const createGuest = async (payload) => {
    vereist('createGuest', { payload });

    spoor("Creating guest", {});

    return axiosInstance.post(apiEndpoints?.CREATE_GUEST, payload);
};

export const getWebshopOpeningHours = async (date, key) => {
    vereist('getWebshopOpeningHours', { date, key });

    spoor("Fetching webshop opening hours", { date, key });

    const antwoord = await axiosInstance.get(apiEndpoints.GET_WEBSHOP_OPENINGHOURS(date, key));

    return antwoord.data;
};

export const getCurrencyData = async (key) => {
    vereist('getCurrencyData', { key });

    spoor("Fetching currency data", { key });

    const antwoord = await axiosInstance.get(apiEndpoints.CURRENCY_ENDPOINT(key));

    return antwoord.data;
};

export const getWebshopFields = async (key, lang) => {
    vereist('getWebshopFields', { key, lang });

    spoor("Fetching webshop fields", { key, lang });

    const antwoord = await axiosInstance.get(apiEndpoints.GET_WEBSHOP_FIELDS(key, lang));

    return antwoord.data;
};

// De webshop-opties van deze widget (golf 1C, 10-10-2026). Gooit niet: zonder opties de standaard (lib/webshopOpties).
export const getWebshopWidgetOpties = async (key, widgetSetupId) => {
    vereist('getWebshopWidgetOpties', { key, widgetSetupId });

    spoor("Fetching webshop widget options", { key, widgetSetupId });

    try {
        const antwoord = await axiosInstance.get(apiEndpoints.GET_WEBSHOP_WIDGET_OPTIES(key, widgetSetupId));
        return antwoord.data;
    } catch {
        return null;
    }
};

// De bewerkmodus (golf 1C): alleen met het teken uit het dashboard, in de kop X-Jimani-Bewerken.
export const controleerBewerkmodus = async (key) => {
    const antwoord = await axiosInstance.get(apiEndpoints.BEWERKEN_CONTROLE(key), { headers: bewerkKoppen() });
    return antwoord.data;
};

export const haalBewerkproduct = async (key, lang, idproduct) => {
    const antwoord = await axiosInstance.get(apiEndpoints.BEWERKEN_PRODUCT(key, lang, idproduct), { headers: bewerkKoppen() });
    return antwoord.data;
};

export const bewaarBewerkproduct = async (key, lang, product) => {
    const antwoord = await axiosInstance.post(apiEndpoints.BEWERKEN_PRODUCT(key, lang), product, { headers: bewerkKoppen() });
    return antwoord.data;
};

// AI-voorstellen in de bewerkmodus (11-10-2026): een concept voor beschrijving of allergenen; er wordt niets opgeslagen.
export const vraagBewerkvoorstel = async (key, lang, vraag) => {
    const antwoord = await axiosInstance.post(apiEndpoints.BEWERKEN_VOORSTEL(key, lang), vraag, { headers: bewerkKoppen() });
    return antwoord.data;
};

export const haalBewerkAitegoed = async (key) => {
    const antwoord = await axiosInstance.get(apiEndpoints.BEWERKEN_AITEGOED(key), { headers: bewerkKoppen() });
    return antwoord.data;
};

// De diensten hierboven heten gewoon const; hier gaan ze naar buiten.
export {
  FetchWebShopCategories,
  FetchWebShopProductList,
  FetchWebshopProductsInfo,
  CreateWebShopOrder,
  FetchWebshopSettings,
  createGuest,
  FetchDeliverySlots,
  fetchExternalDeviceConfig,
};
